import styled from 'styled-components';
import { shade } from 'polished';

export const Container = styled.button`
  background: ${props => props.theme['red-500']};
  height: 56px;
  border-radius: ${props => props.theme['--border-radius']};
  border: 0;
  padding: 0 1rem;
  color: #fff;
  width: 100%;
  font-weight: 500;
  margin-top: 1rem;
  transition: background-color 0.2s;

  &:hover {
    background: ${shade(0.2, '#ff0000')};
  }
`;
